<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <div class="form-element__radiobutton">
      <div class="form-element__radiobutton__item" :class="{ '-picked': item.name == picked }" v-for="item in options" :key="`option-${item.name}`">
        <input type="radio" name="option" :id="item.name" :value="item.name" v-model="picked" />
        <label :for="item.name">
          {{ item.name }}
        </label>
      </div>
    </div>
    <div class="form-element__message" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      picked: this.value
    }
  },
  watch: {
    value: function (val) {
      this.picked = val
    },
    picked: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>